import React, { useState, useEffect, useCallback } from 'react';
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { firestore } from '../../firebase/firebaseConfig';
import NewsPreview from '../../admin-function/NewsPreview';

const NewsWide = () => {
  const [newsList, setNewsList] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const fetchNews = useCallback(async () => {
    const newsCollection = collection(firestore, 'news');
    const newsQuery = query(
      newsCollection,
      where('publication_status', '==', 1),
      orderBy('publish_date', 'desc')
    );

    const newsSnapshot = await getDocs(newsQuery);
    const newsData = newsSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setNewsList(newsData);
  }, []);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const openPopup = (news) => {
    setSelectedNews(news);
    setTimeout(() => {
      setIsVisible(true);
    }, 0);
  };

  const closePopup = () => {
    setIsVisible(false);
    setTimeout(() => {
      setSelectedNews(null);
    }, 500);
  };

  const handlePopupClick = (event) => {
    event.stopPropagation();
  };

  const pageStyle = {
    backgroundColor: '#f0f0f0',
    paddingTop: '40px',
    paddingBottom: '40px',
    textAlign: 'center',
  };

  const pageTitleStyle = {
    fontSize: '24px',
    marginBottom: '20px',
  };

  const cardContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  };

  const cardStyle = {
    width: '80%',
    maxWidth: '640px',
    backgroundColor: '#fff',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    margin: '0px',
    padding: '8px 16px',
    cursor: 'pointer',
    borderRadius: '8px',
  };

  const cardContentWrapper = {
    display: 'flex',
    width: '100%',
    gap: '16px',
    alignItems: 'flex-start',
  };

  const textContainerStyle = {
    flex: 8,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'left',
  };

  const imageContainerStyle = {
    flex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const titleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '0',
  };

  const bodyStyle = {
    fontSize: '14px',
    padding: '0',
    margin: '0',
  };

  const dateStyle = {
    fontSize: '12px',
    color: '#888',
    margin: '0',
  };

  const imageStyle = {
    height: '80px',
    width: 'auto',
    borderRadius: '4px',
  };

  // HTMLを除去してテキストだけ取り出す関数
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  return (
    <div style={pageStyle}>
      <h2 style={pageTitleStyle}>お知らせ</h2>
      <div style={cardContainerStyle}>
        {newsList.map((news) => (
          <div
            key={news.id}
            style={cardStyle}
            onClick={() => openPopup(news)}
          >
            <div style={cardContentWrapper}>
              <div style={textContainerStyle}>
                <h3 style={titleStyle}>{news.title}</h3>
                <p style={dateStyle}>{new Date(news.publish_date).toLocaleDateString()}</p>
                <div style={bodyStyle}>
                  {truncateText(stripHtml(news.html_content), 28)}
                </div>
              </div>
              {news.image_url && (
                <div style={imageContainerStyle}>
                  <img src={news.image_url} alt={news.title} style={imageStyle} />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {selectedNews && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 0.5s',
          }}
          onClick={closePopup}
        >
          <div
            style={{
              backgroundColor: '',
              padding: '0px',
              maxWidth: '800px',
              width: '90%',
            }}
            onClick={handlePopupClick}
          >
            <NewsPreview
              title={selectedNews.title}
              content={selectedNews.html_content}
              image={selectedNews.image_url}
              createdAt={new Date(selectedNews.publish_date).toLocaleDateString()}
            />
          </div>
          <button
            onClick={closePopup}
            style={{
              alignSelf: 'center',
              fontSize: '36px',
              color: 'white',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsWide;
